import React from 'react';

const FinancialTracker = () => {
  return <div>Financial Tracker is Available in React</div>;
};

export default FinancialTracker;
